import { FC } from 'react';

interface CurrencyIcon {
  color?: boolean;
}

export const BCNX: FC<CurrencyIcon> = ({ color = false }) => {
  return color ? (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      preserveAspectRatio="xMinYMid"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 19.1v-.89c0-.805.093-.89.888-.89h8.002c.804 0 .888-.093.888-.89v-2.322c0-.806-.093-.89-.888-.89H7.112c-.804 0-.888-.094-.888-.89v-.89c0-.806.094-.89.888-.89h7.778c.804 0 .888-.084.888-.89V7.56c0-.806-.093-.89-.888-.89H6.888C6.084 6.67 6 6.576 6 5.78v-.89c0-.796.093-.89.888-.89h8.89c1.973 0 2.889.909 2.889 2.895v2.763c0 .806-.094.89-.888.89h-1.113c-.804 0-.888.094-.888.89v.89c0 .806.084.89.888.89h1.113c.803 0 .888.084.888.89v.983c0 .806-.066.956-.627 1.518l-2.757 2.763c-.552.553-.71.628-1.515.628h-6.88C6.084 20 6 19.916 6 19.11v-.01z"
        fill="url(#paint0_linear_137_2744)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_137_2744"
          x1={18}
          y1={5}
          x2={4.88139}
          y2={18.3837}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.0885417} stopColor="#FC7038" />
          <stop offset={0.322917} stopColor="#FB439C" />
          <stop offset={0.682292} stopColor="#0BB4FF" />
          <stop offset={0.953125} stopColor="#04EF7F" />
        </linearGradient>
      </defs>
    </svg>
  ) : (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      preserveAspectRatio="xMinYMid"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6 19.1v-.89c0-.805.093-.89.888-.89h8.002c.804 0 .888-.093.888-.89v-2.322c0-.806-.093-.89-.888-.89H7.112c-.804 0-.888-.094-.888-.89v-.89c0-.806.094-.89.888-.89h7.778c.804 0 .888-.084.888-.89V7.56c0-.806-.093-.89-.888-.89H6.888C6.084 6.67 6 6.576 6 5.78v-.89c0-.796.093-.89.888-.89h8.89c1.973 0 2.889.909 2.889 2.895v2.763c0 .806-.094.89-.888.89h-1.113c-.804 0-.888.094-.888.89v.89c0 .806.084.89.888.89h1.113c.803 0 .888.084.888.89v.983c0 .806-.066.956-.627 1.518l-2.757 2.763c-.552.553-.71.628-1.515.628h-6.88C6.084 20 6 19.916 6 19.11v-.01z" />
    </svg>
  );
};

export const USDT: FC<CurrencyIcon> = ({ color = false }) => {
  return color ? (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      preserveAspectRatio="xMinYMid"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.392 8.747h.5V6.598h-.5v-.46H7.15v2.65h3.273v.178c-.992.063-1.873.209-2.543.409-.385.115-.728.256-.986.427-.233.155-.531.428-.531.835v1.237c0 .41.302.68.536.832.258.168.6.304.984.416.67.195 1.55.34 2.54.416v2.753h3.196v-2.828c.992-.063 1.872-.209 2.542-.409.385-.115.728-.256.986-.427.233-.156.531-.428.531-.835v-.469l.085-.09-.085-.102v-.576c0-.41-.302-.68-.536-.832-.258-.168-.6-.304-.984-.416-.669-.195-1.549-.34-2.54-.416v-.144h2.774zm-8.31 2.484a6.2 6.2 0 01.502-.144c.528-.13 1.186-.235 1.923-.29v.851a13.847 13.847 0 01-1.63-.213 6.612 6.612 0 01-.795-.204zm5.578.41v-.845c.739.053 1.398.15 1.926.276.182.044.345.09.488.138-.241.082-.533.158-.872.225-.45.09-.97.16-1.542.206z"
        fill="#fff"
        stroke="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.325 4h11.558c.29 0 .538.165.662.371l3.356 5.813c.165.288.124.7-.124.948l-9.239 9.152a.779.779 0 01-1.076 0l-9.238-9.111a.81.81 0 01-.124-.948L5.704 4.37A.684.684 0 016.324 4zm10.067 2.598v1.649h-3.273v1.112c2.32.124 4.059.62 4.059 1.196v1.237c0 .577-1.74 1.113-4.06 1.195v2.803h-2.195v-2.72c-2.32-.124-4.06-.62-4.06-1.196v-1.237c0-.577 1.74-1.113 4.06-1.196V8.287H7.65V6.638h8.742v-.04zm-4.35 5.606c2.486 0 4.515-.412 5.054-.99-.415-.494-1.99-.865-3.936-.948v1.196c-.373 0-.704.041-1.077.041s-.745 0-1.076-.041v-1.196c-1.948.083-3.522.495-3.936.948.414.578 2.485.99 4.97.99z"
        fill="#009393"
      />
    </svg>
  ) : (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      preserveAspectRatio="xMinYMid"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.325 4h11.558c.29 0 .538.165.662.371l3.356 5.813c.165.288.124.7-.124.948l-9.239 9.152a.779.779 0 01-1.076 0l-9.238-9.111a.81.81 0 01-.124-.948L5.704 4.37A.684.684 0 016.324 4zm10.067 2.598v1.649h-3.273v1.112c2.32.124 4.059.62 4.059 1.196v1.237c0 .577-1.74 1.113-4.06 1.195v2.803h-2.195v-2.72c-2.32-.124-4.06-.62-4.06-1.196v-1.237c0-.577 1.74-1.113 4.06-1.196V8.287H7.65V6.638h8.742v-.04zm-4.35 5.606c2.486 0 4.515-.412 5.054-.99-.415-.494-1.99-.865-3.936-.948v1.196c-.373 0-.704.041-1.077.041s-.745 0-1.076-.041v-1.196c-1.948.083-3.522.495-3.936.948.414.578 2.485.99 4.97.99z"
      />
    </svg>
  );
};
